import { render } from "./Main.vue?vue&type=template&id=fa055ccc"
const script = {}
script.render = render

export default script